import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { BENEFITS_KEY, PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { FormValidation, SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { TEXT_FIELDS } from '../../customer-service.service';
import { ManageTemplateComponent } from '../../manage-template/manage-template.component';
import { PlanCardComponent } from '../../plan-card/plan-card.component';

@Component({
  selector: 'app-manage-business-contact',
  standalone: true,
  imports: [CommonModule, ManageTemplateComponent, PlanCardComponent],
  templateUrl: './manage-business-contact.component.html',
  styleUrls: ['./manage-business-contact.component.scss',
    '../../../../../../styles/admin/style.scss',
    '../../../../../../styles/admin/app.scss']
})

export class ManageBusinessContactComponent extends FormValidation {

  PLANMAX : number = 0;
  AVAILABLE : number = 0;
  ALLOCATED : number = 0;
  columns : Array<Partial<TEXT_FIELDS>>;
  businessNetworkDetails !: any;
  userDatas = new BehaviorSubject([]);
  businessData: any;
  prevSearchAfterKey : any;
  stopScroll : boolean = false;
  payload = {
    searchContent : null,
    status : null,
    searchAfterKey : null,
    businessId : null,
    limit : 10,
    groupType: 'MANAGE'
  };
  filterData =  [
    {
    label: 'Status',
    payload : 'status',
    options: [
      { value: 'CONNECTED', label: 'Active' },
      { value: 'INACTIVE', label: 'Inactive' },
    ]
    },
    {
      label: 'Business Type',
      payload : 'type',
      options: [
      { value: 'Client', label: 'Client' },
      { value: 'Supplier', label: 'Supplier' },
      // Mutual type. The value sent is the canonical "Client_Supplier"; the
      // backend (B2BContactDao.expandContactTypes) widens it to every spelling
      // actually present in contactType / peerContactType — "Client/Supplier"
      // from the Add-Business form and legacy "Customer/Supplier" — so the
      // bucket isn't split by how the row happened to be written.
      { value: 'Client_Supplier', label: 'Client/Supplier' },
    ],
    },
    {
      label: 'Network',
      payload : 'businessNetworkId',
      options: [  ]
    }
  ];
  allocationCards = [
    {
      name : "Plan Max",
      value : null
    },
    {
      name : "Allocated",
      value : null
    },
    {
      name : "Active",
      value : null
    },
  ];

  constructor(private API: ApiService, private _activated_route: ActivatedRoute ,
    private pricePlanService: PricePlanService , private util : UtilService) {
    super();
    this.columns = [
      { label: "Business Name", key: "businessName",route : true , path : '/user-management/businessContacts/businessConnectEdit' },
      { label: "Owner", key: "businessOwner" },
      { label: "Email", key: "businessEmail" },
      { label: "Role", key: "role"},
      { label: "Business Type", key: "type" },
      { label: "Network", key: "businessNetworks" },

     ];

     this.businessNetworkDetails = {
       networkName : "test",
       owner : "test@gmail.com",
       members : 10
     }



     this._activated_route.parent.data.subscribe(res => {
       this.businessData = res.data;
     });


   }

  ngOnInit(): void {
      this.payload.businessId = this.businessData.id;
      this.getContactsList();
      this.loadB2BNetworks();
  }

  allNetworks: any[] = [];
  activeCount:number;
  loadB2BNetworks() {
    const data: any = {
      "businessId": this.businessData.id,
     "limit":50
    };

    this.API.create('business/findB2BNetworks', data).subscribe(res => {
      const networks = res.data.b2bNetworks;

      if(res?.data?.activeCount && this.payload.searchAfterKey==null || res?.data?.activeCount==0 && this.payload.searchAfterKey==null){
        this.activeCount= res?.data?.activeCount;
      }

      if (networks && networks.length > 0) {
        const mappedData = networks.map(({ b2bNetworkName, b2bNetworkId, ...rest }) => {
          return {
            value: b2bNetworkId,
            label: b2bNetworkName,
            ...rest
          };
        });
        this.allNetworks = [...this.allNetworks, ...mappedData];
        this.filterData[2].options = this.allNetworks;
      }
    });
  }


  getCustomerUsersList(userPayload: Object): Observable<any> {
    return this.API.create('business/findB2BContactsList', userPayload);
  }

  // Display label for the mutual Business Type. contactType / peerContactType is
  // stored as "Client_Supplier" (canonical), "Client/Supplier" (what the
  // Add-Business form writes) or legacy "Customer/Supplier"; all three are the
  // same bucket and must read as one label. Mirrors business-contacts-details
  // formatBusinessType and the networkTypeLabel pipe.
  private formatBusinessType(type: string): string {
    if (!type) { return type; }
    const normalized = type.trim().toLowerCase();
    return (normalized === 'client_supplier'
         || normalized === 'client/supplier'
         || normalized === 'customer/supplier'
         || normalized === 'customer_supplier')
      ? 'Client/Supplier'
      : type;
  }

  total:number;
  getContactsList() {
    this.util.startLoader();
    this.payload.status=this.payload.status==null?"CONNECTED,INACTIVE":this.payload.status
    this.getCustomerUsersList(this.payload).subscribe(response=>{
      if(response) {
        this.util.stopLoader();
      }
      if (response.code ===  GigsumoConstants.SUCESSCODE) {
        const contacts = response.data.b2bContacts;

      // if(response?.data?.total && this.payload.searchAfterKey==null || response?.data?.total==0 && this.payload.searchAfterKey==null){
      //   this.total= response?.data?.total;
      // }
        contacts.forEach(contact => {
          contact.role = "Super Admin";
          // The Business Type column renders item[field.key] raw (manage-template
          // is generic and applies no pipe), so fold the stored spellings of the
          // mutual type into the one label the filter offers. Display only —
          // nothing downstream reads contact.type.
          contact.type = this.formatBusinessType(contact.type);
        });
        const searchKey = response.data.searchAfterKey;

        if (contacts) {
          const current = contacts;
          const exist = this.userDatas.getValue();
          this.userDatas.next([...exist , ...current]);
        }

        if(contacts != null && (contacts.length === 0 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))){
          this.stopScroll = true;
        }
        this.prevSearchAfterKey =  searchKey;
        let plan = response.data.businessPlanUsage;
        let found =  (plan.benefitsUsages && plan.benefitsUsages.
          find(x => (x.benefitKey as BENEFITS_KEY) === 'B2B_CONTACTS'));
        if(found){
          this.PLANMAX = found.actual == 99999999 ? 'Unlimited' : found.actual;
          this.ALLOCATED = found.utilized;
          this.AVAILABLE = found.utilized;

          this.allocationCards[0].value = this.PLANMAX;
          this.allocationCards[1].value = this.ALLOCATED;
        }

        this.allocationCards[2].value = response.data.activeCount;
      }
    });
  }

  updateBusinessNetwork(event) {

  }


  async updateContactMembers(members) {
    const userData = members.value;

    let data = {
      businessId : this.businessData.id,
      peerBusinessId : userData.businessId,
      contactStatus : userData.connectionStatus
    };
    const  updatedData =  JSON.parse(JSON.stringify(this.userDatas.getValue()));


    if(members.checked){
      this.util.startLoader();
      const plan = await this.getBusinessPLanBenefits();
      if(plan.available > 0){
         this.updateMembersBulk(data);
      }
      else{
        updatedData.forEach(res=>{
          if(res.businessId === userData.businessId){
            res.connectionStatus = "INACTIVE";
          }
        });
        this.userDatas.next(updatedData);
        this.pricePlanService.expiredPopup(
          "B2B_CONTACTS",
          "PAY",
          null,
          null,
          null,
          null,
          plan.available,
          plan.actual,
          plan.utilized,
          plan.promotional
        );
        this.util.stopLoader();
      }


    }
    else if(!members.checked){
      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        title : "Inactive Business Contacts",
        allowOutsideClick : false,
        text : `Are you sure you want to inactive ${userData.businessName}?`
      }).then(res=>{
        this.util.startLoader();

        if(res.isConfirmed){
          this.updateMembersBulk(data);
          this.util.stopLoader();
        }
        else{
          updatedData.forEach(res=>{
            if(res.businessId === userData.businessId){
              res.connectionStatus = "CONNECTED";
            }
          });
          this.userDatas.next(updatedData);
          this.util.stopLoader();
        }


      });
    }

  }


  updateMembersBulk(data){
    this.util.startLoader();
     this.API.create("business/updateB2BContact" , data).subscribe(response=>{
      this.util.stopLoader();
        if(response.code === GigsumoConstants.SUCESSCODE){
             Swal.fire({
              icon : "success",
              title : "Contact updated successfully",
              showConfirmButton: false,
              timer: 2000,
            });

            setTimeout(() => {
                this.payload.searchAfterKey = null;
                this.prevSearchAfterKey = null;
                this.stopScroll = false;
                this.userDatas.next([]);
                this.getContactsList();
             }, 1000);
            this.util.stopLoader();

        }
    });
  }


  async getBusinessPLanBenefits() {
    const userPlan: any = await this.API.lamdaFunctionsget('findBusinessPlanBenefits/' + this.businessData.id);
    const plan = userPlan.data.businessPlanAndBenefits.benefitsUsages;
    if (plan) {
      return plan.find(x => x.benefitKey === "B2B_CONTACTS");
    }
  }


  onSearch(value , obj : ManageBusinessContactComponent){
    obj.payload = {
      ...obj.payload,
      searchContent : value,
      searchAfterKey : null
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getContactsList();
  }

  onFilter(data , obj : ManageBusinessContactComponent){

    let d;
    if(data.businessNetworkId){
     d = structuredClone(data.businessNetworkId).join(',');
    }
    obj.payload = {
      ...obj.payload,
      searchAfterKey : null,
      ...data,
      type : data.type || null,
      businessNetworkId : d
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    // obj.payload.status=obj.payload.status==null?"CONNECTED,INACTIVE":obj.payload.status
    obj.payload.status = data.status ?? null;
    obj.userDatas.next([]);
    obj.getContactsList();
  }

  onScroll(obj : ManageBusinessContactComponent){
    if(!this.stopScroll){
      obj.payload = {
        ...obj.payload,
        searchAfterKey : obj.prevSearchAfterKey
      };
      obj.getContactsList();
    }
  }
}
